import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { Membership } from 'src/features/membership/types';
import { MembershipFormSchemaValues } from 'src/features/membership/formSchema';

const RESOURCE = `sp-core/:parkingId/memberships/membership/:membershipId/`;

type MutationFnType = typeof mutationFn;

interface DTO extends MembershipFormSchemaValues {
    parkingId: string;
    membershipId: string;
}
const mutationFn = ({ parkingId, membershipId, ...data }: DTO): Promise<Membership> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, membershipId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateMembership };
